import React from "react";
import { frameImg } from "../utils/constants";

function HeartFeltMessage() {
  return (
    <div className="short-mesage-root">
      <div>
        <h2>A letter from Taki</h2>
        <p>
          Mitsuha, <br />
          There was a time when I didn’t know your name, yet I searched for you everywhere. <br /> A time when I held your hand but couldn’t remember your face.{" "}
          <br /> A time when I called out to you, knowing only that you were important… even when the world tried to erase you from my heart.
          <br /> <br />
          Now, I know. I know that no matter how many seasons pass, no matter how far apart we are, I will always find my way back to you. Because meeting you
          wasn’t just fate—it was a promise written in the stars. If one day, I forget again, find me. And if you ever feel lost, know that I am always looking
          for you. Because I love you. <br />
          Because your name… is the only thing my heart will never forget.
          <br />– Taki
        </p>
        <img src={frameImg} alt="" />
        <p className="quote">"No matter where, no matter when, I’ll always find you." 💙✨</p>
        <button>"Look, Mitsuha… I made this, just for you." ✨💙</button>
      </div>
    </div>
  );
}

export default HeartFeltMessage;
